(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('NewsService', NewsService)

    /** @ngInject */
    function NewsService(HttpService) {
        const NewsService = {
            getAllByParameters: getAllByParameters,
            get: get
        }

        return NewsService;

        function getAllByParameters(params) {
            return HttpService.get('/informatives', {
                params
            });
        }

        function get(informativeId) {
            return HttpService.get(`/informatives/${informativeId}`);
        }
    }
}());